(() => {
  const initializeLabs = () => {
    document.querySelectorAll('[data-rpg-game-lab]').forEach(async (lab) => {
      if (lab.dataset.rpgBadgeReady === 'true') return;

      const dialog = lab.querySelector('.rpg-badge-dialog');
      const content = lab.querySelector('[data-rpg-badge-content]');
      const closeButton = lab.querySelector('[data-rpg-badge-close]');
      const offerDialog = lab.querySelector('.rpg-offer-dialog');
      const offerContent = lab.querySelector('[data-rpg-offer-content]');
      const offerCloseButton = lab.querySelector('[data-rpg-offer-close]');
      if (!dialog || !content || !closeButton || !offerDialog || !offerContent || !offerCloseButton) return;

      lab.dataset.rpgBadgeReady = 'true';

      const catalogGrid = lab.querySelector('[data-rpg-catalog-grid]');
      const catalogPool = lab.querySelector('[data-rpg-catalog-card-pool]');
      const catalogCards = catalogPool
        ? Array.from(catalogPool.content.querySelectorAll('.rpg-game-card'))
        : catalogGrid
          ? Array.from(catalogGrid.querySelectorAll('.rpg-game-card'))
          : [];
      const catalogSearch = lab.querySelector('[data-rpg-catalog-search]');
      const catalogSort = lab.querySelector('[data-rpg-catalog-sort]');
      const catalogType = lab.querySelector('[data-rpg-catalog-type]');
      const catalogGrade = lab.querySelector('[data-rpg-catalog-grade]');
      const catalogIncluded = lab.querySelector('[data-rpg-catalog-included]');
      const catalogClear = lab.querySelector('[data-rpg-catalog-clear]');
      const catalogStatus = lab.querySelector('[data-rpg-catalog-status]');
      const catalogPagination = lab.querySelector('[data-rpg-catalog-pagination]');
      const catalogControls = lab.querySelector('[data-rpg-catalog-controls]');
      const filterDrawer = lab.querySelector('[data-rpg-filter-drawer]');
      const filterOpeners = lab.querySelectorAll('[data-rpg-filter-open]');
      const floatingFilter = lab.querySelector('[data-rpg-filter-floating]');
      const filterCounts = lab.querySelectorAll('[data-rpg-filter-count]');
      const activeFilters = lab.querySelector('[data-rpg-active-filters]');
      const filterApply = lab.querySelector('[data-rpg-filter-apply]');
      const priceMin = lab.querySelector('[data-rpg-price-min]');
      const priceMax = lab.querySelector('[data-rpg-price-max]');

      const customSelects = [];
      const enhanceSelect = (select) => {
        if (!select || select.dataset.rpgSelectReady === 'true') return null;
        select.dataset.rpgSelectReady = 'true';
        select.tabIndex = -1;
        select.setAttribute('aria-hidden', 'true');

        const shell = document.createElement('div');
        shell.className = 'rpg-themed-select';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rpg-themed-select__button';
        button.setAttribute('aria-haspopup', 'listbox');
        button.setAttribute('aria-expanded', 'false');
        const value = document.createElement('span');
        value.className = 'rpg-themed-select__value';
        const chevron = document.createElement('span');
        chevron.className = 'rpg-themed-select__chevron';
        chevron.setAttribute('aria-hidden', 'true');
        chevron.textContent = '⌄';
        button.append(value, chevron);

        const menu = document.createElement('div');
        menu.className = 'rpg-themed-select__menu';
        menu.setAttribute('role', 'listbox');
        menu.hidden = true;

        let closeTimer = 0;
        const close = () => {
          window.clearTimeout(closeTimer);
          shell.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          closeTimer = window.setTimeout(() => { menu.hidden = true; }, 180);
        };
        const refresh = () => {
          const selected = select.options[select.selectedIndex];
          value.textContent = selected?.textContent || '';
          const label = select.previousElementSibling?.textContent?.trim();
          button.setAttribute('aria-label', `${label ? `${label}: ` : ''}${selected?.textContent || ''}`);
          menu.querySelectorAll('[role="option"]').forEach((option) => {
            const isSelected = option.dataset.value === select.value;
            option.classList.toggle('is-selected', isSelected);
            option.setAttribute('aria-selected', String(isSelected));
          });
        };

        Array.from(select.options).forEach((option) => {
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'rpg-themed-select__option';
          item.dataset.value = option.value;
          item.setAttribute('role', 'option');
          item.textContent = option.textContent;
          item.addEventListener('click', () => {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            refresh();
            close();
            button.focus();
          });
          menu.append(item);
        });

        button.addEventListener('click', () => {
          const willOpen = !shell.classList.contains('is-open');
          customSelects.forEach((control) => control.close());
          if (!willOpen) return;
          window.clearTimeout(closeTimer);
          menu.hidden = false;
          requestAnimationFrame(() => shell.classList.add('is-open'));
          button.setAttribute('aria-expanded', 'true');
        });
        button.addEventListener('keydown', (event) => {
          if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
          event.preventDefault();
          if (!shell.classList.contains('is-open')) button.click();
          const options = [...menu.querySelectorAll('[role="option"]')];
          const current = Math.max(0, options.findIndex((option) => option.classList.contains('is-selected')));
          options[Math.max(0, Math.min(options.length - 1, current + (event.key === 'ArrowDown' ? 1 : -1)))]?.focus();
        });
        menu.addEventListener('keydown', (event) => {
          const options = [...menu.querySelectorAll('[role="option"]')];
          const current = options.indexOf(document.activeElement);
          if (event.key === 'Escape') {
            event.preventDefault();
            close();
            button.focus();
          } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            options[Math.max(0, Math.min(options.length - 1, current + (event.key === 'ArrowDown' ? 1 : -1)))]?.focus();
          }
        });

        select.after(shell);
        shell.append(button, menu);
        select.classList.add('rpg-themed-select__native');
        const control = { shell, close, refresh };
        customSelects.push(control);
        refresh();
        return control;
      };

      [catalogSort, catalogType, catalogGrade, catalogIncluded].forEach(enhanceSelect);

      const configureCatalogChat = () => {
        const chat = document.querySelector('shopify-chat');
        if (!chat?.shadowRoot || chat.dataset.rpgCatalogReady === 'true') return Boolean(chat?.shadowRoot);
        const style = document.createElement('style');
        style.textContent = `
          @media (max-width: 1024px) {
            .activator__label { display: none !important; }
            .activator {
              width: 50px !important;
              min-width: 50px !important;
              height: 50px !important;
              padding: 0 !important;
              justify-content: center !important;
            }
          }
        `;
        chat.shadowRoot.append(style);
        chat.dataset.rpgCatalogReady = 'true';
        return true;
      };
      if (!configureCatalogChat()) {
        const chatObserver = new MutationObserver(() => {
          if (configureCatalogChat()) chatObserver.disconnect();
        });
        chatObserver.observe(document.documentElement, { childList: true, subtree: true });
      }
      document.addEventListener('click', (event) => {
        customSelects.forEach((control) => {
          if (!control.shell.contains(event.target)) control.close();
        });
      });
      // Keep the full catalog searchable in the inert template, but only mount a
      // useful browsing page. This prevents off-page cards, images, forms and
      // offer templates from participating in live layout/style work.
      const pageSize = 32;
      const catalogParams = new URLSearchParams(window.location.search);
      const requestedType = catalogParams.get('rpg_type') || '';
      const requestedSort = catalogParams.get('rpg_sort') || '';
      const requestedIncluded = catalogParams.get('rpg_included') || '';
      const requestedTypeHandles = {
        games: 'game',
        consoles: 'console',
        controllers: 'controller',
        accessories: 'accessory',
      };
      const requestedTypeHandle = requestedTypeHandles[requestedType] || '';
      let selectedType = requestedTypeHandle;
      let catalogPage = 1;

      if (requestedType) {
        const typeLabel = requestedType.charAt(0).toUpperCase() + requestedType.slice(1);
        const heading = lab.querySelector('.rpg-game-lab__intro h1');
        if (heading && !heading.textContent.trim().toLowerCase().endsWith(requestedType.toLowerCase())) {
          heading.textContent = `${heading.textContent.trim()} ${typeLabel}`;
        }
        if (catalogSearch) {
          catalogSearch.placeholder = `Search ${typeLabel.toLowerCase()}`;
          catalogSearch.previousElementSibling.textContent = `Search ${typeLabel.toLowerCase()}`;
        }
      }

      const splitValues = (value, separator = ' ') => (value || '')
        .split(separator)
        .map((item) => item.trim())
        .filter(Boolean);

      const totalProducts = Number(lab.dataset.rpgTotalProducts || catalogCards.length);
      const sourcePageSize = Number(lab.dataset.rpgPageSize || 250);
      const sourcePages = Math.max(1, Math.ceil(totalProducts / sourcePageSize));

      const mergeCardData = (target, source) => {
        ['rpgGrade', 'rpgIncluded'].forEach((datasetKey) => {
          const merged = new Set([...splitValues(target.dataset[datasetKey]), ...splitValues(source.dataset[datasetKey])]);
          target.dataset[datasetKey] = [...merged].join(' ');
        });
        ['rpgGenres', 'rpgModes'].forEach((datasetKey) => {
          const merged = new Set([...splitValues(target.dataset[datasetKey], '||'), ...splitValues(source.dataset[datasetKey], '||')]);
          target.dataset[datasetKey] = [...merged].join('||');
        });
        const targetCreated = Number(target.dataset.rpgCreated || 0);
        const sourceCreated = Number(source.dataset.rpgCreated || 0);
        if (!targetCreated || (sourceCreated && sourceCreated < targetCreated)) target.dataset.rpgCreated = String(sourceCreated);
        const targetPrice = Number(target.dataset.rpgPrice || 0);
        const sourcePrice = Number(source.dataset.rpgPrice || 0);
        if (!targetPrice || (sourcePrice && sourcePrice < targetPrice)) target.dataset.rpgPrice = String(sourcePrice);
      };

      if (sourcePages > 1 && lab.dataset.rpgSectionId) {
        if (catalogStatus) catalogStatus.textContent = 'Loading products…';
        catalogControls?.setAttribute('aria-busy', 'true');
        lab.dataset.rpgLoadedPages = '1';
        lab.dataset.rpgLoadErrors = '0';
        const existingGroups = new Map(catalogCards.map((card) => [card.dataset.gameGroupId, card]));
        const requests = [];
        for (let page = 2; page <= sourcePages; page += 1) {
          const pageUrl = new URL(window.location.href);
          pageUrl.searchParams.set('page', String(page));
          pageUrl.searchParams.set('section_id', lab.dataset.rpgSectionId);
          requests.push(fetch(pageUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then((response) => response.ok ? response.text() : '')
            .then((html) => {
              if (!html) return;
              const documentFragment = new DOMParser().parseFromString(html, 'text/html');
              const fetchedPool = documentFragment.querySelector('[data-rpg-catalog-card-pool]');
              fetchedPool?.content.querySelectorAll('.rpg-game-card').forEach((card) => {
                const groupId = card.dataset.gameGroupId;
                const existing = existingGroups.get(groupId);
                if (existing) {
                  mergeCardData(existing, card);
                  return;
                }
                existingGroups.set(groupId, card);
                catalogCards.push(card);
              });
              lab.dataset.rpgLoadedPages = String(Number(lab.dataset.rpgLoadedPages || 1) + 1);
            })
            .catch(() => {
              lab.dataset.rpgLoadErrors = String(Number(lab.dataset.rpgLoadErrors || 0) + 1);
            }));
        }
        await Promise.all(requests);
        catalogControls?.removeAttribute('aria-busy');
      }

      const filterKeys = ['platform', 'grade', 'included', 'genre', 'mode', 'era'];
      const filterState = Object.fromEntries(filterKeys.map((key) => [key, new Set()]));
      if (['complete', 'game-box', 'game-only'].includes(requestedIncluded)) filterState.included.add(requestedIncluded);
      const optionLabels = Object.fromEntries(filterKeys.map((key) => [key, new Map()]));
      const validSorts = new Set(['newest', 'oldest', 'price-descending', 'price-ascending']);
      let sortBy = validSorts.has(requestedSort) ? requestedSort : (catalogSort?.value || 'newest');
      let currentFilteredCards = [];

      const cardValues = (card, key) => {
        if (key === 'platform') return card.dataset.rpgPlatform ? [card.dataset.rpgPlatform] : [];
        if (key === 'grade') return splitValues(card.dataset.rpgGrade);
        if (key === 'included') return splitValues(card.dataset.rpgIncluded);
        if (key === 'genre') return splitValues(card.dataset.rpgGenres, '||').map((value) => value.toLowerCase());
        if (key === 'mode') return splitValues(card.dataset.rpgModes, '||').map((value) => value.toLowerCase());
        if (key === 'era') return card.dataset.rpgEra ? [card.dataset.rpgEra.toLowerCase()] : [];
        return [];
      };

      const fixedLabels = {
        grade: { new: 'New', excellent: 'Excellent', good: 'Good', fair: 'Fair' },
        included: { complete: 'Complete', 'game-box': 'Game & Box', 'game-only': 'Disc/Cart Only' },
      };

      catalogCards.forEach((card) => {
        filterKeys.forEach((key) => {
          cardValues(card, key).forEach((value) => {
            let label = fixedLabels[key]?.[value] || value;
            if (key === 'platform') label = card.dataset.rpgPlatformLabel || value;
            if (key === 'genre' || key === 'mode') {
              const originals = splitValues(card.dataset[key === 'genre' ? 'rpgGenres' : 'rpgModes'], '||');
              label = originals.find((item) => item.toLowerCase() === value) || value;
            }
            if (key === 'era') label = card.dataset.rpgEra || value;
            optionLabels[key].set(value, label);
          });
        });
      });

      const matchesCard = (card, skipKey = '') => {
        const term = (catalogSearch?.value || '').trim().toLowerCase();
        const cardType = card.dataset.rpgProductType || '';
        const matchesType = !selectedType || cardType === selectedType;
        const matchesTerm = !term || `${card.dataset.rpgSearch || card.dataset.rpgTitle || ''} ${card.dataset.rpgPlatform || ''}`.includes(term);
        if (!matchesType || !matchesTerm) return false;

        const cardPrice = Number(card.dataset.rpgPrice || 0) / 100;
        const minimum = Number(priceMin?.value || 0);
        const maximum = Number(priceMax?.value || 0);
        if (skipKey !== 'price' && ((minimum && cardPrice < minimum) || (maximum && cardPrice > maximum))) return false;

        return filterKeys.every((key) => {
          if (key === skipKey || filterState[key].size === 0) return true;
          const values = cardValues(card, key);
          return values.some((value) => filterState[key].has(value));
        });
      };

      const sortedCards = (cards) => [...cards].sort((left, right) => {
        if (sortBy === 'price-ascending') return Number(left.dataset.rpgPrice || 0) - Number(right.dataset.rpgPrice || 0);
        if (sortBy === 'price-descending') return Number(right.dataset.rpgPrice || 0) - Number(left.dataset.rpgPrice || 0);
        if (sortBy === 'oldest') return Number(left.dataset.rpgCreated || 0) - Number(right.dataset.rpgCreated || 0);
        return Number(right.dataset.rpgCreated || 0) - Number(left.dataset.rpgCreated || 0);
      });

      const optionOrder = (key, [valueA, labelA], [valueB, labelB]) => {
        const preferred = {
          grade: ['new', 'excellent', 'good', 'fair'],
          included: ['complete', 'game-box', 'game-only'],
          era: ['2020s', '2010s', '2000s', '1990s', '1980s', 'before 1980'],
        }[key];
        if (preferred) {
          const positionA = preferred.indexOf(valueA);
          const positionB = preferred.indexOf(valueB);
          if (positionA !== positionB) return (positionA < 0 ? 999 : positionA) - (positionB < 0 ? 999 : positionB);
        }
        return labelA.localeCompare(labelB, undefined, { numeric: true });
      };

      const buildFilterOptions = () => {
        filterKeys.forEach((key) => {
          const container = lab.querySelector(`[data-rpg-filter-options="${key}"]`);
          const group = lab.querySelector(`[data-rpg-filter-group="${key}"]`);
          if (!container || !group) return;
          const entries = [...optionLabels[key].entries()].sort((a, b) => optionOrder(key, a, b));
          group.hidden = entries.length === 0 || (entries.length < 2 && key === 'platform');
          container.replaceChildren();
          entries.forEach(([value, label]) => {
            const option = document.createElement('label');
            option.className = 'rpg-filter-option';
            const input = document.createElement('input');
            input.type = 'checkbox';
            input.value = value;
            input.dataset.rpgFilterKey = key;
            const text = document.createElement('span');
            text.className = 'rpg-filter-option__label';
            text.textContent = label;
            const count = document.createElement('span');
            count.className = 'rpg-filter-option__count';
            count.dataset.rpgOptionCount = `${key}:${value}`;
            count.textContent = '0';
            option.append(input, text, count);
            container.append(option);
          });
        });
      };

      const syncControls = () => {
        if (catalogSort) catalogSort.value = sortBy;
        if (catalogType) catalogType.value = selectedType;
        lab.querySelectorAll('[data-rpg-filter-options="sort"] input').forEach((input) => { input.checked = input.value === sortBy; });
        if (catalogGrade) catalogGrade.value = filterState.grade.size === 1 ? [...filterState.grade][0] : '';
        if (catalogIncluded) catalogIncluded.value = filterState.included.size === 1 ? [...filterState.included][0] : '';
        lab.querySelectorAll('[data-rpg-filter-key]').forEach((input) => {
          input.checked = filterState[input.dataset.rpgFilterKey]?.has(input.value) || false;
        });
        customSelects.forEach((control) => control.refresh());
      };

      const selectedFilterCount = () => filterKeys.reduce((total, key) => total + filterState[key].size, 0)
        + (priceMin?.value ? 1 : 0) + (priceMax?.value ? 1 : 0);

      const updateFilterCounts = () => {
        filterKeys.forEach((key) => {
          optionLabels[key].forEach((_label, value) => {
            const count = catalogCards.filter((card) => matchesCard(card, key) && cardValues(card, key).includes(value)).length;
            const countNode = lab.querySelector(`[data-rpg-option-count="${CSS.escape(`${key}:${value}`)}"]`);
            const input = lab.querySelector(`[data-rpg-filter-key="${key}"][value="${CSS.escape(value)}"]`);
            if (countNode) countNode.textContent = String(count);
            if (input) input.disabled = count === 0 && !input.checked;
          });
        });

        const activeCount = selectedFilterCount();
        filterCounts.forEach((node) => {
          node.textContent = String(activeCount);
          node.hidden = activeCount === 0;
        });
        if (floatingFilter) floatingFilter.classList.toggle('is-active', activeCount > 0);
      };

      const renderActiveFilters = () => {
        if (!activeFilters) return;
        activeFilters.replaceChildren();
        filterKeys.forEach((key) => {
          filterState[key].forEach((value) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.rpgRemoveFilter = `${key}:${value}`;
            button.textContent = `${optionLabels[key].get(value) || value} ×`;
            activeFilters.append(button);
          });
        });
        if (priceMin?.value || priceMax?.value) {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.rpgRemoveFilter = 'price:';
          button.textContent = `$${priceMin?.value || '0'}–${priceMax?.value ? `$${priceMax.value}` : 'Any'} ×`;
          activeFilters.append(button);
        }
        activeFilters.hidden = !activeFilters.children.length;
      };

      buildFilterOptions();

      const renderCatalog = () => {
        if (!catalogGrid || !catalogPagination) return;
        const filtered = sortedCards(catalogCards.filter((card) => matchesCard(card)));
        currentFilteredCards = filtered;

        const pages = Math.max(1, Math.ceil(filtered.length / pageSize));
        catalogPage = Math.min(catalogPage, pages);
        const start = (catalogPage - 1) * pageSize;
        const visibleCards = filtered.slice(start, start + pageSize);
        const pageFragment = document.createDocumentFragment();

        visibleCards.forEach((card) => {
          card.hidden = false;
          pageFragment.append(card);
        });
        catalogGrid.replaceChildren(pageFragment);
        catalogGrid.dataset.rpgCatalogTotal = String(catalogCards.length);
        catalogGrid.setAttribute('aria-busy', 'false');

        if (catalogStatus) {
          if (!filtered.length) {
            catalogStatus.textContent = `No ${requestedType || 'products'} match those filters.`;
          } else {
            catalogStatus.textContent = `Showing ${start + 1}–${Math.min(start + pageSize, filtered.length)} of ${filtered.length} ${requestedType || 'products'}`;
          }
        }

        if (filterApply) filterApply.textContent = `Show ${filtered.length} ${filtered.length === 1 ? 'product' : 'products'}`;
        syncControls();
        updateFilterCounts();
        renderActiveFilters();

        catalogPagination.replaceChildren();
        if (pages <= 1) {
          catalogPagination.hidden = true;
          return;
        }
        catalogPagination.hidden = false;

        const makeButton = (label, page, options = {}) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = label;
          button.className = `rpg-game-lab__page-button${options.current ? ' is-current' : ''}`;
          button.disabled = options.disabled || false;
          button.dataset.rpgCatalogPage = String(page);
          if (options.current) button.setAttribute('aria-current', 'page');
          return button;
        };

        catalogPagination.append(makeButton('Previous', Math.max(1, catalogPage - 1), { disabled: catalogPage === 1 }));
        const first = Math.max(1, Math.min(catalogPage - 2, pages - 4));
        const last = Math.min(pages, Math.max(5, catalogPage + 2));
        for (let page = first; page <= last; page += 1) {
          catalogPagination.append(makeButton(String(page), page, { current: page === catalogPage }));
        }
        catalogPagination.append(makeButton('Next', Math.min(pages, catalogPage + 1), { disabled: catalogPage === pages }));
      };

      // Pagination buttons are recreated after every filter change. Delegate
      // from the persistent nav so all engines use one stable event path and
      // rerenders do not allocate another set of button listeners.
      catalogPagination?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-rpg-catalog-page]');
        if (!button || button.disabled) return;
        const requestedPage = Number(button.dataset.rpgCatalogPage);
        if (!Number.isInteger(requestedPage) || requestedPage < 1 || requestedPage === catalogPage) return;
        catalogPage = requestedPage;
        renderCatalog();
        lab.querySelector('.rpg-game-lab__controls')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      catalogSearch?.addEventListener('input', () => {
        catalogPage = 1;
        renderCatalog();
      });
      catalogSort?.addEventListener('change', () => {
        sortBy = catalogSort.value;
        catalogPage = 1;
        renderCatalog();
      });
      catalogType?.addEventListener('change', () => {
        selectedType = catalogType.value;
        catalogPage = 1;
        renderCatalog();
      });
      [[catalogGrade, 'grade'], [catalogIncluded, 'included']].forEach(([control, key]) => {
        control?.addEventListener('change', () => {
          filterState[key].clear();
          if (control.value) filterState[key].add(control.value);
          catalogPage = 1;
          renderCatalog();
        });
      });

      filterDrawer?.addEventListener('change', (event) => {
        const input = event.target;
        if (input.matches('[data-rpg-filter-key]')) {
          const key = input.dataset.rpgFilterKey;
          input.checked ? filterState[key].add(input.value) : filterState[key].delete(input.value);
        } else if (input.matches('[data-rpg-filter-options="sort"] input')) {
          sortBy = input.value;
        } else {
          return;
        }
        catalogPage = 1;
        renderCatalog();
      });
      [priceMin, priceMax].forEach((input) => input?.addEventListener('input', () => {
        catalogPage = 1;
        renderCatalog();
      }));

      activeFilters?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-rpg-remove-filter]');
        if (!button) return;
        const [key, value] = button.dataset.rpgRemoveFilter.split(':');
        if (key === 'price') {
          if (priceMin) priceMin.value = '';
          if (priceMax) priceMax.value = '';
        } else {
          filterState[key]?.delete(value);
        }
        catalogPage = 1;
        renderCatalog();
      });

      catalogClear?.addEventListener('click', () => {
        if (catalogSearch) catalogSearch.value = '';
        filterKeys.forEach((key) => filterState[key].clear());
        selectedType = '';
        if (priceMin) priceMin.value = '';
        if (priceMax) priceMax.value = '';
        sortBy = 'newest';
        catalogPage = 1;
        renderCatalog();
      });

      filterOpeners.forEach((button) => button.addEventListener('click', () => {
        if (!filterDrawer?.open) filterDrawer?.showModal();
        document.documentElement.classList.add('rpg-filter-open');
      }));
      filterDrawer?.addEventListener('close', () => document.documentElement.classList.remove('rpg-filter-open'));
      filterDrawer?.addEventListener('click', (event) => {
        if (event.target === filterDrawer) filterDrawer.close();
      });

      if (catalogControls && floatingFilter && 'IntersectionObserver' in window) {
        let controlsVisible = true;
        let floatingHideTimer = 0;
        const syncFloatingFilter = () => {
          const labRect = lab.getBoundingClientRect();
          const shouldShow = !controlsVisible && labRect.bottom >= 120 && labRect.top <= window.innerHeight;
          window.clearTimeout(floatingHideTimer);
          if (shouldShow) {
            floatingFilter.hidden = false;
            requestAnimationFrame(() => floatingFilter.classList.add('is-visible'));
          } else {
            floatingFilter.classList.remove('is-visible');
            floatingHideTimer = window.setTimeout(() => { floatingFilter.hidden = true; }, 240);
          }
        };
        new IntersectionObserver(([entry]) => {
          controlsVisible = entry.isIntersecting;
          syncFloatingFilter();
        }, { threshold: 0.05 }).observe(catalogControls);
        window.addEventListener('scroll', syncFloatingFilter, { passive: true });
      }
      renderCatalog();

      const syncDialogScrollLock = () => {
        document.documentElement.classList.toggle('rpg-dialog-open', dialog.open || offerDialog.open);
      };

      lab.addEventListener('click', (event) => {
        const badge = event.target.closest('[data-rpg-badge-info]');
        if (!badge || !lab.contains(badge)) return;

        const template = lab.querySelector(`[data-rpg-badge-template="${badge.dataset.rpgBadgeInfo}"]`);
        if (!template) return;

        content.replaceChildren(template.content.cloneNode(true));

        if (badge.hasAttribute('data-rpg-grade-note')) {
          const note = lab.querySelector('[data-rpg-badge-template="grade-note"]');
          if (note) content.append(note.content.cloneNode(true));
        }

        if (offerDialog.open) offerDialog.close();
        dialog.showModal();
        syncDialogScrollLock();
      });

      lab.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-rpg-offer-open]');
        if (!trigger || !lab.contains(trigger)) return;
        event.preventDefault();

        const template = lab.querySelector(`[data-rpg-offer-template="${trigger.dataset.rpgOfferOpen}"]`);
        if (!template) return;

        offerContent.replaceChildren(template.content.cloneNode(true));
        offerDialog.showModal();
        syncDialogScrollLock();
      });

      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', syncDialogScrollLock);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      offerCloseButton.addEventListener('click', () => offerDialog.close());
      offerDialog.addEventListener('close', syncDialogScrollLock);
      offerDialog.addEventListener('click', (event) => {
        if (event.target === offerDialog) offerDialog.close();
      });

      lab.addEventListener('submit', async (event) => {
        const form = event.target.closest('.js-product-form');
        if (!form || !lab.contains(form)) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const button = form.querySelector('[name="add"]');
        const originalLabel = button ? button.textContent : '';
        if (button && button.getAttribute('aria-disabled') === 'true') return;

        if (button) {
          button.setAttribute('aria-disabled', 'true');
          button.classList.add('is-loading');
          button.textContent = 'Adding…';
        }

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(form)
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this copy.');

          if (offerDialog.open) offerDialog.close();

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.refresh === 'function') {
            await cartDrawer.refresh(true);
            cartDrawer.open(button);
          } else {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
              bubbles: true,
              detail: { opener: button }
            }));

            window.setTimeout(() => {
              if (!cartDrawer || cartDrawer.getAttribute('aria-hidden') === 'false') return;
              const overlay = document.querySelector('.js-overlay');
              cartDrawer.setAttribute('open', '');
              cartDrawer.setAttribute('aria-hidden', 'false');
              if (overlay) overlay.classList.add('is-visible');

              const closeFallback = (closeEvent) => {
                if (!closeEvent.target.closest('.js-close-drawer') && closeEvent.target !== overlay) return;
                cartDrawer.removeAttribute('open');
                cartDrawer.setAttribute('aria-hidden', 'true');
                if (overlay) overlay.classList.remove('is-visible');
                cartDrawer.removeEventListener('click', closeFallback);
                if (overlay) overlay.removeEventListener('click', closeFallback);
              };
              cartDrawer.addEventListener('click', closeFallback);
              if (overlay) overlay.addEventListener('click', closeFallback);
            }, 350);
          }

          if (button) button.textContent = 'Added!';
        } catch (error) {
          if (button) button.textContent = error.message || 'Try again';
        } finally {
          window.setTimeout(() => {
            if (!button) return;
            button.removeAttribute('aria-disabled');
            button.classList.remove('is-loading');
            button.textContent = originalLabel;
          }, 1200);
        }
      }, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLabs, { once: true });
  } else {
    initializeLabs();
  }

  document.addEventListener('shopify:section:load', initializeLabs);
})();
